import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, GoogleButton } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { CheckCircle } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ ad_soyad: "", email: "", password: "", biyografi: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Başvurun alındı" subtitle="">
        <div className="text-center py-6" data-testid="register-success">
          <CheckCircle className="text-sage mx-auto" size={56} />
          <p className="text-ink-2 mt-6 leading-relaxed">
            Üyeliğin başarıyla oluşturuldu! Artık hemen giriş yapabilir,
            kütüphaneni oluşturmaya ve toplulukla paylaşmaya başlayabilirsin.
          </p>
          <Link to="/giris"><Button className="mt-8 bg-terra hover:bg-terra-hover text-white rounded-lg h-11 px-6">Giriş sayfasına dön</Button></Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Topluluğa katıl" subtitle="Okuma yolculuğuna başlamak için üye ol.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="ad">Ad Soyad</Label>
          <Input id="ad" data-testid="register-name" required value={form.ad_soyad}
            onChange={(e) => setForm({ ...form, ad_soyad: e.target.value })} className="mt-1 h-11" />
        </div>
        <div>
          <Label htmlFor="email">E-posta</Label>
          <Input id="email" data-testid="register-email" type="email" required value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 h-11" />
        </div>
        <div>
          <Label htmlFor="password">Şifre</Label>
          <Input id="password" data-testid="register-password" type="password" required minLength={6} value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 h-11" />
        </div>
        <div>
          <Label htmlFor="bio">Kısa biyografi (opsiyonel)</Label>
          <Textarea id="bio" data-testid="register-bio" value={form.biyografi}
            onChange={(e) => setForm({ ...form, biyografi: e.target.value })} className="mt-1" rows={2} />
        </div>
        <Button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full h-11 bg-terra hover:bg-terra-hover text-white rounded-lg">
          {loading ? "Gönderiliyor..." : "Üyelik Başvurusu Yap"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-5">
        <div className="h-px bg-line flex-1" /><span className="text-xs text-muted-foreground">veya</span><div className="h-px bg-line flex-1" />
      </div>
      <GoogleButton />
      <p className="text-sm text-center text-ink-2 mt-6">
        Zaten üye misin? <Link to="/giris" className="text-terra font-medium hover:underline">Giriş yap</Link>
      </p>
    </AuthShell>
  );
}
